import {connect} from "react-redux";
import TollView from "./View";
import {bindActionCreators} from "redux";
import {tollById} from "../../../../service/FasttagToll/action";

const mapStateToProps = (state) => ({
    tollView:state.FasttagToll.tollView
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            tollById
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TollView);
